import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';
import {MposDate} from 'app/blocks/util/mpos-date';
import {IRoute} from 'app/blocks/model/route.model';
import {IDeliveryPoint} from 'app/blocks/model/delivery-point.model';
import {ISchedule} from 'app/blocks/model/schedule.model';
import {IEmployee} from 'app/blocks/model/employee.model';
import {ITelesalesScheduleDeliveryPoint} from 'app/blocks/model/telesales-schedule-delivery-point.model';

export interface ITelesalesSchedule extends IBaseEntity {
    id?: number;
    name: string;
    description: string;
    schedule: ISchedule;
    startDate: any;
    endDate: any;
    lastGeneratedDate: any;
    telesalesRepresentative?: IEmployee;
    deliveryPoints?: IDeliveryPoint[]; // For GET response - now includes sequence field
    telesalesScheduleDeliveryPoints?: ITelesalesScheduleDeliveryPoint[]; // For POST/PUT requests
}

export class TelesalesSchedule extends BaseEntity implements ITelesalesSchedule {
    public id?: number;
    public name: string;
    public description: string;
    public schedule: ISchedule;
    public startDate: any;
    public endDate: any;
    public lastGeneratedDate: any;
    public telesalesRepresentative?: IEmployee;
    public deliveryPoints?: IDeliveryPoint[]; // For GET response - now includes sequence field
    public telesalesScheduleDeliveryPoints?: ITelesalesScheduleDeliveryPoint[]; // For POST/PUT requests

    constructor(telesalesSchedule?) {
        super();
        if (telesalesSchedule) {
            this.id = telesalesSchedule.id;
            this.name = telesalesSchedule.name || '';
            this.description = telesalesSchedule.description || '';
            this.schedule = telesalesSchedule.schedule || null;
            this.startDate = telesalesSchedule.startDate ? MposDate.newInstance(telesalesSchedule.startDate) : null;
            this.endDate = telesalesSchedule.endDate ? MposDate.newInstance(telesalesSchedule.endDate) : null;
            this.lastGeneratedDate = telesalesSchedule.lastGeneratedDate ? new MposDate(telesalesSchedule.lastGeneratedDate) : null;
            this.telesalesRepresentative = telesalesSchedule.telesalesRepresentative || null;
            this.deliveryPoints = telesalesSchedule.deliveryPoints || [];
            this.telesalesScheduleDeliveryPoints = telesalesSchedule.telesalesScheduleDeliveryPoints || [];
        }
    }

    get discriminator(): any {
        return this.name;
    }

    clone(): TelesalesSchedule {
        return new TelesalesSchedule(this);
    }
}
